import { render, staticRenderFns } from "./UpdateInfo.vue?vue&type=template&id=753e08c1"
import script from "./UpdateInfo.vue?vue&type=script&lang=js"
export * from "./UpdateInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports